import { RelatableVideoType } from "@/type/commonTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface videoMPModalState {
  isOpen: boolean;
  video?: string | null;
}

const initialState: videoMPModalState = {
  isOpen: false,
  video: null,
};

const videoMPModalSlice = createSlice({
  name: "videoMPModal",
  initialState,
  reducers: {
    openVideoMPModal: (state, action: PayloadAction<string>) => {
      state.isOpen = true;
      state.video = action.payload;
    },
    closeVideoMPModal: (state) => {
      state.isOpen = false;
      state.video = null;
    },
  },
});

export const { openVideoMPModal, closeVideoMPModal } = videoMPModalSlice.actions;
export default videoMPModalSlice.reducer;
